import { IUnifiedRolesDomain } from '../../../UnifiedRoles';
import {
  IUserTenantAgnosticRoles,
  IUserTenantAgnosticRolesConstructor,
} from '../interfaces';

export class UserTenantAgnosticRoles implements IUserTenantAgnosticRoles {
  public unifiedRolesEditor: IUnifiedRolesDomain.IRolesEditorPolicy;

  private constructor(
    private readonly payload: IUserTenantAgnosticRolesConstructor,
  ) {
    this.unifiedRolesEditor =
      this.payload.unifiedRolesFactory.createUnifiedRolesEditorPolicy({});
  }

  public readonly getUserTenantAgnosticRoles =
    async (): Promise<IUnifiedRolesDomain.IRolesEditorPolicy> => {
      const { userTenantAgnosticUnifiedRoles, allTenantAgnosticUnifiedRoles } =
        await this.composeUserTenantSpecificUnifiedRolesPayload();

      this.unifiedRolesEditor =
        this.payload.unifiedRolesFactory.createUnifiedRolesEditorPolicy({
          unifiedRolesAssignedToResource: userTenantAgnosticUnifiedRoles,
          allAvailableUnifiedRoles: allTenantAgnosticUnifiedRoles,
        });

      return this.unifiedRolesEditor;
    };

  public readonly updateUserTenantAgnosticRoles = async (
    userUnifiedRoles: IUnifiedRolesDomain.TUnifiedRoleCollectionDto,
  ): Promise<void> => {
    await this.payload.userTenantAgnosticUnifiedRolesUpdateCommand.execute(
      this.payload.userPrincipal,
      {
        tenant: this.payload.tenant,
        user: this.payload.user,
        unifiedRoles: userUnifiedRoles,
      },
    );
  };

  public static create(
    payload: IUserTenantAgnosticRolesConstructor,
  ): UserTenantAgnosticRoles {
    return new UserTenantAgnosticRoles(payload);
  }

  private readonly composeUserTenantSpecificUnifiedRolesPayload =
    async (): Promise<{
      userTenantAgnosticUnifiedRoles: IUnifiedRolesDomain.TUnifiedRoleCollectionDto;
      allTenantAgnosticUnifiedRoles: IUnifiedRolesDomain.TUnifiedRoleCollectionDto;
    }> => {
      const [
        { userTenantAgnosticUnifiedRoles },
        { allTenantAgnosticUnifiedRoles },
      ] = await Promise.all([
        this.payload.userTenantAgnosticUnifiedRolesQuery.execute(
          this.payload.userPrincipal,
          {
            tenant: this.payload.tenant,
            user: this.payload.user,
          },
        ),
        this.payload.allTenantAgnosticUnifiedRolesQuery.execute(
          this.payload.userPrincipal,
        ),
      ]);

      return {
        userTenantAgnosticUnifiedRoles,
        allTenantAgnosticUnifiedRoles,
      };
    };
}
